import * as yup from 'yup';

export const cloneFormSchema = yup.object({
  regions: yup.array().of(yup.string()),
  configs: yup.array().of(yup.string()),
  resourceGroups: yup.array().of(yup.string()),
});

export type CloneFormSchema = yup.InferType<typeof cloneFormSchema>;
